import React from 'react';
import vendorAppImg from './images/shared_image_(13).jpg';

const VendorSection = () => {
    return (
        <section className="vendor-section" id="vendor">
            <div className="container">
                <div className="section-header reveal">
                    <div className="section-eyebrow">The Vendor App</div>
                    <h2>Everything a salon owner needs,<br />in one powerful app.</h2>
                    <p>My Salon Hub Vendor is built exclusively for salon professionals. Manage every aspect of your business
                        from a single, intuitive dashboard.</p>
                </div>

                <div className="vendor-showcase reveal">
                    <div className="vendor-showcase-left">
                        <div className="vendor-tag">
                            <div className="vtag-icon"><i className="fa-solid fa-store"></i></div>
                            <div>
                                <div className="vtag-label">My Salon Hub</div>
                                <div className="vtag-name">Vendor App</div>
                            </div>
                            <span className="vtag-badge">For Salon Owners</span>
                        </div>

                        <div className="vendor-features-grid">
                            <div className="vf-card">
                                <div className="vf-icon" style={{ background: 'rgba(124,77,255,0.1)', color: '#7C4DFF' }}><i
                                    className="fa-solid fa-chart-line"></i></div>
                                <div className="vf-text">
                                    <h4>Dashboard &amp; Analytics</h4>
                                    <p>Real-time revenue tracking, booking counts, and business growth insights at a glance.</p>
                                </div>
                            </div>
                            <div className="vf-card">
                                <div className="vf-icon" style={{ background: 'rgba(23,178,152,0.1)', color: '#17B298' }}><i
                                    className="fa-solid fa-calendar-check"></i></div>
                                <div className="vf-text">
                                    <h4>Booking Management</h4>
                                    <p>Filter by All, Pending, or Complete. Approve or reject bookings with one tap.</p>
                                </div>
                            </div>
                            <div className="vf-card">
                                <div className="vf-icon" style={{ background: 'rgba(255,94,138,0.1)', color: '#FF5E8A' }}><i
                                    className="fa-solid fa-clipboard-user"></i></div>
                                <div className="vf-text">
                                    <h4>Staff Attendance &amp; Payroll</h4>
                                    <p>Track daily check-in/check-out for each employee and manage payroll seamlessly.</p>
                                </div>
                            </div>
                            <div className="vf-card">
                                <div className="vf-icon" style={{ background: 'rgba(255,183,77,0.1)', color: '#FFB74D' }}><i
                                    className="fa-solid fa-wallet"></i></div>
                                <div className="vf-text">
                                    <h4>Expense Tracker</h4>
                                    <p>Log and filter all overhead costs by month to keep your finances crystal clear.</p>
                                </div>
                            </div>
                            <div className="vf-card">
                                <div className="vf-icon" style={{ background: 'rgba(13,152,219,0.1)', color: '#0D98DB' }}><i
                                    className="fa-solid fa-scissors"></i></div>
                                <div className="vf-text">
                                    <h4>Dynamic Services</h4>
                                    <p>Create, categorize, and price your services with active status controls.</p>
                                </div>
                            </div>
                            <div className="vf-card">
                                <div className="vf-icon" style={{ background: 'rgba(124,77,255,0.1)', color: '#7C4DFF' }}><i
                                    className="fa-solid fa-bullhorn"></i></div>
                                <div className="vf-text">
                                    <h4>Offers &amp; Promotions</h4>
                                    <p>Push live deals and package offers directly to your salon's profile page.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="vendor-showcase-right">
                        <div className="vs-phone">
                            <div className="vs-notch"></div>
                            <img src={vendorAppImg} alt="Vendor App View"
                                style={{ width: '100%', height: 'auto', display: 'block' }} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VendorSection;
